<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">待完成病例列表</div>
				<div class="titleR">
					
				</div>
			</div>
			<div class="content">
				<div class="con">
					<!-- <div class="tabLine">
						<div class="tabLineL">
							
						</div>
						<div class="tabLineR">
							
						</div>
					</div>
					<div class="searchLine">
						<div class="searchLineL">
							
						</div>
						<div class="searchLineR"></div>
					</div> -->
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="单号" min-width="40">
								<template slot-scope="props">
									<div>{{props.row.caseNumber}}</div>
								</template>
							</el-table-column>
							<el-table-column label="顾客" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.memberName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="手机号" min-width="60">
								<template slot-scope="props">
									<div>{{props.row.memberMobile}}</div>
								</template>
							</el-table-column>
							<el-table-column label="宠物" min-width="80">
								<template slot-scope="props">
									<div>
										{{props.row.petName}} ({{props.row.sex}}) 
										{{props.row.birthDay&&props.row.birthDay.length>4?($public.FAge(new Date(props.row.birthDay).getTime())[0]+'岁'+$public.FAge(new Date(props.row.birthDay).getTime())[1]+'月'):''}}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="品种" min-width="50">
								<template slot-scope="props">
									<div>{{props.row.typeName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="经办人" min-width="40">
								<template slot-scope="props">
									<div>{{props.row.doctorName}}</div>
								</template>
							</el-table-column>
							<el-table-column label="症状" min-width="90">
								<template slot-scope="props">
									<div v-for="tag1 in props.row.diagnosisTags" :key="tag1.key">
										<span >{{tag1.value}}-</span>
										<span v-for="tag2 in tag1.symptom" :key="tag2.key">
											<span v-for="tag3 in tag2.symptomLevel" :key="tag3.key">
												<span >{{tag2.value}}-</span>
												<span >{{tag3.value}}; </span>
											</span>
										</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="康复情况" min-width="40">
								<template slot-scope="props">
									<span v-if="props.row.completeState===1">治愈中</span>
									<span v-if="props.row.completeState===2">已治愈</span>
									<span v-if="props.row.completeState===3">死亡</span>
								</template>
							</el-table-column>
							<el-table-column label="状态" min-width="40">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="医生" min-width="40">
								<template slot-scope="props">
									{{props.row.doctorName}}
								</template>
							</el-table-column>
							<el-table-column label="病例日期" min-width="50">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="检测" min-width="40">
								<template slot-scope="props">
									<div style="color:#FD4E4E">{{props.row.isInspect==0?'未检测':''}}</div>
									<div style="color:#18A44C">{{props.row.isInspect==1?'已检测':''}}</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" min-width="50">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="see_bingli(props.row)">查看</el-button>
									<el-button v-show="$buttonAuthority('yewu-yiliaoxin-editbingli')" type="text" @click="edit_bingli(props.row)" size="mini">编辑</el-button>
									<el-button v-show="$buttonAuthority('yewu-yiliaoxin-delbingli')" v-if="props.row.isPay==false" type="text" @click="del_bingli(props.row)" size="mini">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			loginInfo(){
				return this.$store.state.userInfo
			},
			rightBingliParams(){
				return this.$store.state.yiliaoxin.rightBingliParams
			}
		},
		created(){
			
		},
		mounted(){
			this.page = this.rightBingliParams.initialDataOflist.page||this.page;
			this.getTableData();
		},
		methods: {
			see_bingli(row){
				let obj = this.$store.state.yiliaoxin.bingliParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_bingliParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'病例')
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
			},
			edit_bingli(row){
				let obj = this.$store.state.yiliaoxin.bingliParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_bingliParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'病例')
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
			},
			del_bingli(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/Case/Delete', {caseNumber:row.caseNumber}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					isPay:-1, // 是否支付（-1不限；0未支付；1已支付）
					isInspect:-1,  // 是否检测（-1不限；0未检测；1已检测）
					isOut:0, // 是否录入药品（-1不限；0未录入；1已录入；2部分录入）
					completeState:1, // 康复情况 1治疗中；2已治愈；3死亡
					showLater:false,
					hasOrder:false,
					hasGoods:false,
					doctorId:this.loginInfo.staffId,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": '',
				}
				let loading=this.$loading();
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.rightBingliParams.initialDataOflist = {
					page:JSON.parse(JSON.stringify(this.page)),
				}
				this.$store.commit("yiliaoxin/set_rightBingliParams",JSON.parse(JSON.stringify(this.rightBingliParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'rBingli',data:JSON.parse(JSON.stringify(this.rightBingliParams))})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 121px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
